export class ResourceCellRenderer implements agGrid.ICellRendererComp {
    private gui: HTMLElement;

    refresh(params: any): boolean {
      params.$scope.$applyAsync();

      return true;
    }

    getGui(): HTMLElement {
      return this.gui;
    }

    init?(params: agGrid.ICellRendererParams): void | agGrid.Promise<void> {
      this.gui = $(`<div class="media iio-resource-media"
             ng-class="{ 'bg-warning': data.hadProcessingException, 'bg-danger': data.hasVirus}"
             ng-style="{'margin-left': $parent.noIndent ? 'inherit' : '{{data.numberOfAncestors * 50}}px'}"
             uib-tooltip="{{ data.processingException }}">

            <div class="checkbox checkbox-primary" ng-if="$parent.rowSelection !== 'CheckboxOff'">
              <input id="rowNode.rowIndex" type="checkbox" ng-checked="rowNode.selected" ng-click="rowNode.setSelected(!rowNode.selected)">
              <label for="rowNode.rowIndex" style="pointer-events:none;">
              </label>
            </div>

            <i class="fas fa-lg pull-left"
               ng-class="{'fa-archive': data.type == 'container', 'fa-file-archive': data.type == 'phone image', 'fa-comments': data.type == 'extracted conversation', 'fa-envelope': data.type == 'email', 'fa-file': data.type == 'file', 'fa-mobile': data.type == 'phone image metadata', 'fa-comment': data.type == 'instant message', 'fa-sms': data.type == 'mms' || data.type == 'sms', 'fa-voicemail': data.type == 'voicemail', 'fa-sticky-note' : data.type == 'note'}"></i>

            <div ng-switch on="data.type">
                <div ng-switch-when="email">
                    <h4 class="media-heading clearfix">
                        <span style="margin-top: -2px;"  class="pull-left text-primary" ng-show="data.emailFrom">{{ data.emailFrom }}</span>
                        <small class="pull-right text-primary" ng-show="data.isTopParent || data.isTopParentResource">{{ data.createdDate }}</small>
                    </h4>
                    <h5>{{ data.title || 'No Subject' }}</h5>

                    <small class="text-muted" ng-show="$parent.showCollections">
                        <i class="far fa-hdd"></i> {{ data.collectionName }}
                    </small>
                    <small class="text-muted" style="margin-left: 1px; width: 90%; overflow: hidden; text-overflow: ellipsis">
                        <i class="far fa-folder"></i> {{ data.folders || "/" }}
                    </small>

                    <div class="resource-thumbnail-overlay" style="margin-top: -75px;">
                        <img ng-if="data.directPdfThumbnailPath && $parent.rowSelection !== 'CheckboxOff'" ng-src="{{data.directPdfThumbnailPath}}" alt="preview" class="img-thumbnail" popover-trigger="'mouseenter'" popover-placement="left" popover-append-to-body="true" uib-popover-html="thumbnailHtml(data.directPdfThumbnailPath)">
                    </div>
                </div>
                <div ng-switch-when="file|extracted conversation|note" ng-switch-when-separator="|">
                    <h4 class="media-heading clearfix">
                        <span class="pull-left text-primary" style="margin-top: -2px;">{{ data.filename }}</span>
                        <small class="pull-right">{{ data.bytes || 0 | bytes }}</small>
                    </h4>

                    <h5>{{ data.title }}</h5>

                    <small class="text-muted" ng-show="$parent.showCollections">
                        <i class="far fa-hdd"></i> {{ data.collectionName }}
                    </small>
                    <small class="text-muted" style="margin-left: 1px; width: 90%; overflow: hidden; text-overflow: ellipsis">
                        <i class="far fa-folder"></i> {{ data.folders || "/" }}
                    </small>

                    <div class="resource-thumbnail-overlay" ng-style="{'margin-top': data.title ? '-75px' : '-50px'}">
                        <img ng-if="data.directPdfThumbnailPath && $parent.rowSelection !== 'CheckboxOff'" ng-src="{{data.directPdfThumbnailPath}}" alt="preview" class="img-thumbnail" popover-trigger="'mouseenter'" popover-placement="left" popover-append-to-body="true" uib-popover-html="thumbnailHtml(data.directPdfThumbnailPath)">
                    </div>
                </div>
                <div ng-switch-when="container|phone image" ng-switch-when-separator="|">
                    <h4 class="media-heading clearfix">
                        <span class="pull-left text-primary">{{ data.filename }}</span>
                        <small class="pull-right">{{ data.bytes || 0 | bytes }}</small>
                    </h4>

                    <small class="text-muted" ng-show="$parent.showCollections">
                        <i class="far fa-hdd"></i> {{ data.collectionName }}
                    </small>
                    <small class="text-muted" style="margin-left: 1px; width: 90%; overflow: hidden; text-overflow: ellipsis" >
                        <i class="far fa-folder"></i> {{ data.folders || "/" }}
                    </small>
                </div>
                <div ng-switch-when="phone image metadata">
                    <h4 class="media-heading clearfix">
                        <span class="pull-left text-primary">{{ data.filename }}</span>
                        <small class="pull-right">{{ data.bytes || 0 | bytes }}</small>
                    </h4>

                    <small class="text-muted" ng-show="$parent.showCollections">
                        <i class="far fa-hdd"></i> {{ data.collectionName }}
                    </small>
                    <small class="text-muted" style="margin-left: 1px; width: 90%; overflow: hidden; text-overflow: ellipsis" >
                        <i class="far fa-folder"></i> {{ data.folders || "/" }}
                    </small>
                </div>
                <div ng-switch-when="instant message">
                    <h4 class="media-heading clearfix">
                        <span class="pull-left text-primary">{{ data.chatMessage.from.name || data.chatMessage.from.id || data.chatMessage.to[0].name || data.chatMessage.to[0].id }}</span>
                        <small class="pull-right">{{ data.bytes || 0 | bytes }}</small>
                    </h4>

                    <div class="resource-thumbnail-overlay" style="margin-top: -10px;">
                        <img ng-if="data.directPdfThumbnailPath && $parent.rowSelection !== 'CheckboxOff'" ng-src="{{data.directPdfThumbnailPath}}" alt="preview" class="img-thumbnail" popover-trigger="'mouseenter'" popover-placement="left" popover-append-to-body="true" uib-popover-html="thumbnailHtml(data.directPdfThumbnailPath)">
                    </div>

                    <small class="text-muted" ng-show="data.chatMessage.text" style="margin-left: 1px; margin-top: 15px; overflow-wrap: break-word; white-space: normal; line-height: 23px; width: 90%">
                        {{ data.chatMessage.text }}
                    </small>
                </div>
                <div ng-switch-when="sms">
                    <h4 class="media-heading clearfix">
                        <span class="pull-left text-primary">{{ data.chatMessage.from.name || data.chatMessage.from.id || data.chatMessage.to[0].name || data.chatMessage.to[0].id }}</span>
                        <small class="pull-right">{{ data.bytes || 0 | bytes }}</small>
                    </h4>

                    <div class="resource-thumbnail-overlay" style="margin-top: -10px;">
                        <img ng-if="data.directPdfThumbnailPath && $parent.rowSelection !== 'CheckboxOff'" ng-src="{{data.directPdfThumbnailPath}}" alt="preview" class="img-thumbnail" popover-trigger="'mouseenter'" popover-placement="left" popover-append-to-body="true" uib-popover-html="thumbnailHtml(data.directPdfThumbnailPath)">
                    </div>

                    <small class="text-muted" ng-show="data.chatMessage.text" style="margin-left: 1px; overflow-wrap: break-word; white-space: normal; line-height: 30px" >
                        {{ data.chatMessage.text }}
                    </small>
                </div>
                <div ng-switch-when="mms">
                    <h4 class="media-heading clearfix">
                        <span class="pull-left text-primary">{{ data.chatMessage.from.name || data.chatMessage.from.id || data.chatMessage.to[0].name || data.chatMessage.to[0].id}}</span>
                        <small class="pull-right">{{ data.bytes || 0 | bytes }}</small>
                    </h4>

                    <div class="resource-thumbnail-overlay" style="margin-top: -10px;">
                        <img ng-if="data.directPdfThumbnailPath && $parent.rowSelection !== 'CheckboxOff'" ng-src="{{data.directPdfThumbnailPath}}" alt="preview" class="img-thumbnail" popover-trigger="'mouseenter'" popover-placement="left" popover-append-to-body="true" uib-popover-html="thumbnailHtml(data.directPdfThumbnailPath)">
                    </div>

                    <small class="text-muted" ng-show="data.chatMessage.text" style="margin-left: 1px; margin-top: 15px; overflow-wrap: break-word; white-space: normal; line-height: 23px; width: 90%">
                        {{ _.unescape(data.chatMessage.text).trim() }}
                    </small>
                </div>
                <div ng-switch-when="voicemail">
                    <h4 class="media-heading clearfix">
                        <span class="pull-left text-primary">{{ data.filename }}</span>
                        <small class="pull-right">{{ data.bytes || 0 | bytes }}</small>
                    </h4>

                    <small class="text-muted" ng-show="$parent.showCollections">
                        <i class="far fa-hdd"></i> {{ data.collectionName }}
                    </small>
                    <small class="text-muted" style="margin-left: 1px; width: 90%; overflow: hidden; text-overflow: ellipsis" >
                        <i class="far fa-folder"></i> {{ data.folders || "/" }}
                    </small>

                    <div class="resource-thumbnail-overlay" ng-style="{'margin-top': data.title ? '-75px' : '-45px'}">
                        <img ng-if="data.directPdfThumbnailPath && $parent.rowSelection !== 'CheckboxOff'" ng-src="{{data.directPdfThumbnailPath}}" alt="preview" class="img-thumbnail" popover-trigger="'mouseenter'" popover-placement="left" popover-append-to-body="true" uib-popover-html="thumbnailHtml(data.directPdfThumbnailPath)">
                    </div>
                </div>
            </div>
        </div>`).get(0);

      // Build trusted HTML for the thumbnail popover.
      // Memoized so the same object reference is returned on every digest cycle —
      // uib-popover-html watches its value, and $sce.trustAsHtml() creates a new
      // object each call, which would cause an infinite digest loop without caching.
      const $sce = angular.element(document.body).injector().get('$sce');
      const htmlCache = new Map<string, any>();
      params.$scope.thumbnailHtml = (path: string) => {
        if (!path) return '';
        if (!htmlCache.has(path)) {
          htmlCache.set(path, $sce.trustAsHtml(`<img width="400" height="400" src="${path}" alt="preview" class="img-thumbnail">`));
        }
        return htmlCache.get(path);
      };
    }
  }

(window as any).ResourceCellRenderer = ResourceCellRenderer;
